import { IAuthMeV2OutputDto } from '@quadminds/shared/auth-system';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ChatService from '../services/chat.service';

export function useGetConversationBy(id: string, options?: { enabled?: boolean }) {
    const queryClient = useQueryClient();

    const userInfo: IAuthMeV2OutputDto | undefined = queryClient.getQueryData(['userInfo']);

    if (userInfo === undefined) {
        console.error('User info is not available');
    }

    const chatService = new ChatService();

    return useQuery({
        queryFn: async () => {
            const result = await chatService.getConversationBy(id);
            return result;
        },
        queryKey: ['conversation', id],
        enabled: (options?.enabled ?? true) && !!id && !!id.trim(), // ✅ Enhanced condition
        staleTime: 0, // ✅ Always refetch when invalidated
        gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
        retry: 2, // ✅ Add retry logic
    });
}

export default useGetConversationBy;
